import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faCheck,
  faCheckCircle as faSolidCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle as faSolidCircle,
  faDownload,
  faEnvelope as faSolidEnvelope,
  faMinus,
  faPhoneAlt,
  faPlus,
  faQuestionCircle as faSolidQuestionCircle,
  faSearchPlus,
  faTimes,
} from "@fortawesome/free-solid-svg-icons"
import {
  faCheckCircle as faRegularCheckCircle,
  faCircle as faRegularCircle,
  faEnvelope as faRegularEnvelope,
  faQuestionCircle as faRegularQuestionCircle,
} from "@fortawesome/free-regular-svg-icons"
import {
  faFacebook,
  faHouzz,
  faInstagram,
  faPinterest,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons"

config.autoAddCss = false

const solidIcons = {
  "angle-down": faAngleDown,
  "angle-left": faAngleLeft,
  "angle-right": faAngleRight,
  "arrow-to-bottom": faDownload,
  check: faCheck,
  "check-circle": faSolidCheckCircle,
  "chevron-down": faChevronDown,
  "chevron-left": faChevronLeft,
  "chevron-right": faChevronRight,
  "chevron-up": faChevronUp,
  circle: faSolidCircle,
  envelope: faSolidEnvelope,
  minus: faMinus,
  "phone-alt": faPhoneAlt,
  plus: faPlus,
  "question-circle": faSolidQuestionCircle,
  "search-plus": faSearchPlus,
  times: faTimes,
}

const regularIcons = {
  "check-circle": faRegularCheckCircle,
  circle: faRegularCircle,
  envelope: faRegularEnvelope,
  "question-circle": faRegularQuestionCircle,
}

const brandIcons = {
  facebook: faFacebook,
  houzz: faHouzz,
  instagram: faInstagram,
  pinterest: faPinterest,
  twitter: faTwitter,
}

const getIconName = className => {
  const match = String(className || "").match(
    /\bfa-(?!fw\b|lg\b)([a-z0-9-]+)\b/
  )

  return match ? match[1] : null
}

const getIconStyle = className => {
  if (/\bfab\b/.test(className)) return "brand"
  if (/\bfar\b/.test(className)) return "regular"
  return "solid"
}

const getIcon = (name, iconStyle) => {
  if (iconStyle === "brand") return brandIcons[name]
  if (iconStyle === "regular") return regularIcons[name] || solidIcons[name]
  return solidIcons[name] || regularIcons[name] || brandIcons[name]
}

const Icon = ({ className = "", name, children, style, ...props }) => {
  const iconName = name || getIconName(className)
  const icon = getIcon(iconName, getIconStyle(className)) || faSolidCircle

  if (!children) {
    return (
      <FontAwesomeIcon
        {...props}
        className={className}
        icon={icon}
        style={style}
      />
    )
  }

  return (
    <span
      {...props}
      className={className}
      style={{
        alignItems: "center",
        display: "inline-flex",
        justifyContent: "center",
        lineHeight: 1,
        verticalAlign: "-0.125em",
        ...style,
      }}
    >
      <FontAwesomeIcon icon={icon} />
      {children}
    </span>
  )
}

export default Icon
